// Localized content datasets for Danshaker (EN, DE, and reference DA)

export const LOCALIZED_CMS_DATA = {
  en: {
    testimonials: [
      {
        id: "nis-1",
        name: "Nis Friis Virenfeldt",
        company: "DK • 4 reviews • Jan 31, 2026",
        text: "<p><strong>High quality and top-class service!</strong></p><p>We have now had our Danshaker for a year – if we could do anything differently, we should have bought it much sooner!</p><p>It is used daily for 10 horses/ponies and offers significant savings on wood shavings, which also means a significantly longer emptying interval for the muck container!</p><p>We have experienced fantastic service from Rasmus. He is a tech enthusiast who often reaches out to ensure customer satisfaction and is constantly improving the equipment so everyone feels like a winner.</p><p>Highest recommendation from us🙏🐴</p>",
        image: []
      },
      {
        id: "sanne-1",
        name: "Sanne",
        company: "DK • 8 reviews • Feb 2, 2026",
        text: "<p><strong>Fantastic experience with Danshaker</strong></p><p>I had a truly wonderful experience with Danshaker, where Rasmus delivered personal and welcoming service from start to finish. You feel genuinely well-guided and taken care of.</p><p>The product is high quality, and our horses thrive on it. The aerated, fluffy box bedding provides a noticeable improvement in comfort – softer and more flexible for the horse.</p><p>Furthermore, I have seen a reduction in wood pellet consumption, as well as the time we spend on daily stable chores.</p><p>All in all, I warmly recommend Danshaker – thanks to Rasmus’ great service, the high quality, and the increased comfort for the horse.</p>",
        image: []
      },
      {
        id: "1",
        name: "Team Madsbjerg",
        company: "Team Madsbjerg",
        text: "<p>Rasmus from Danshaker stands 100% behind what he says and promises – this is just as important as the product he sells.</p><p>We look forward every day to going to the stable to use the machine.</p><p>The machine is super easy to use and provides a wonderful, airy and soft bed.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/869578f4-4087-49ae-9256-01442dfeaff9.jpg"]
      },
      {
        id: "2",
        name: "Dan Jeppesen",
        company: "Molger Riding Club",
        text: "<p>The machine has made a huge difference in our stable – both for staff and members.</p><p>It has become much easier to maintain the bedding, and everyday chores are noticeably lighter.</p><p>The horses stand much softer, and you can really tell on them – that means everything to us!</p><p>Thank you for a great solution – we are truly delighted with it! Highest recommendations from here.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ee3409b4-4a03-4472-bb2f-a5861cc8d979.jpg"]
      },
      {
        id: "3",
        name: "M-Horses",
        company: "M-Horses",
        text: "<p>We are super pleased with the machine, as it is easy to use, easy to maneuver around, and saves bedding.</p><p>We also spend much less time sorting manure than before.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/dca27bba-1daf-44d2-87c2-ae31a6dff125.jpg"]
      },
      {
        id: "4",
        name: "Michelle Lauridsen",
        company: "Stald Bøgen, Esbjerg",
        text: "<p>We have several horses in our stable that make a large mess in their boxes.</p><p>Previously, sorting in these boxes took 30-40 minutes per box – after getting the Danshaker, that time is down under 10 minutes per box.</p><p>Our stable hand sorts our 10 boxes every day. Usually she was completely exhausted after 4-5 boxes, but with the Danshaker she handles all 10 boxes without issue and has energy left for other tasks. We warmly recommend Danshaker and give it 10/10 stars.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/500774ed-a863-4e49-9e78-26eeb7273db5.jpg"]
      },
      {
        id: "5",
        name: "Odgaard Horses",
        company: "Odgaard Horses",
        text: "<p>We have used the machine daily since the turn of the year and are especially thrilled to avoid the repetitive, straining movements of manual mucking out.</p><p>It is easy to shovel into the machine, and everyone in the stable quickly finds a good rhythm. We are seeing less manure volume and faster sorting, which delivers sustained ongoing savings. A very promising investment.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ce39733b-86c6-4c8a-83d0-06b042411306.jpg"]
      }
    ],
    nyheder: [
      {
        id: "n1",
        title: "Personalize your Danshaker",
        date: "January 19, 2026",
        content: "<p>You can now customize your new Danshaker by choosing the exact RAL color you prefer.</p><p>We also offer a glitter finish in the paint for a minor surcharge.</p><p>All future models now feature all-black front wheels instead of yellow.</p>",
        slug: "customize-your-danshaker"
      },
      {
        id: "n2",
        title: "Private financing",
        date: "January 19, 2026",
        content: "<p>You can now finance your new Danshaker privately from just 1,563 DKK/month incl. VAT.</p><p>We have partnered with flexible financing providers to ensure accessible payment solutions for our customers.</p><p>Split payments over up to 24 months. Contact us today and we will assist you.</p>",
        slug: "private-financing"
      }
    ],
    faq: [
      {
        question: "Does the Danshaker need a power cord while working?",
        answer: "<p>No – you avoid cords entirely. The Danshaker runs on a powerful rechargeable battery, giving you complete freedom to clean stalls wherever and whenever you want.</p>"
      },
      {
        question: "How many stalls can I clean on a single charge?",
        answer: "<p>On a full charge, you can handle up to 86 stalls lasting approx. 10 minutes each. This gives you plenty of capacity – even in large stable facilities.</p>"
      },
      {
        question: "How long does it take to recharge the Danshaker?",
        answer: "<p>From 10% to 100% typically takes 5–6 hours. Plug it in overnight, and it is fully charged and ready for the next working day.</p>"
      },
      {
        question: "How much time do I save by using the Danshaker?",
        answer: "<p>Many of our customers have halved their mucking out time – some save up to 75%. This allows you to spend more time with your horses and less time on heavy manual sorting.</p>"
      },
      {
        question: "How much bedding can I save?",
        answer: "<p>Our customers often experience up to 50% lower bedding consumption – while significantly reducing manure handling and disposal costs.</p>"
      },
      {
        question: "When does the Danshaker typically pay for itself?",
        answer: "<p>This is individual and depends on stable size and bedding habits. On average, our customers save 50% on bedding purchases and muck removal. Daily use with fine bedding material like wood shavings or pellets maximizes your return.</p>"
      },
      {
        question: "What types of bedding does the Danshaker work with?",
        answer: "<p>It has been tested with all common bedding types: wood shavings, wood pellets, sawdust, flax/hemp, and peat. The finer the material, the more clean bedding you retain.</p>"
      },
      {
        question: "Is there any bedding type not suited for the Danshaker?",
        answer: "<p>Yes, we do not recommend using it in traditional long straw bedding or coarse wood chips, as separation is not optimal.</p>"
      },
      {
        question: "Can I adjust the speed of the Danshaker?",
        answer: "<p>Yes – the speed can be easily adjusted via your smartphone so it matches your preferred working pace.</p>"
      },
      {
        question: "Is the Danshaker difficult to clean after use?",
        answer: "<p>No – cleaning takes only about one minute in the wash stall with a water hose. Quick, simple, and ready for next time.</p>"
      },
      {
        question: "Can I retrofit accessories on my Danshaker?",
        answer: "<p>Yes, if you have a Danshaker 2.0 (blue model). All accessories can be retrofitted, allowing you to adapt the machine as your needs evolve.</p>"
      },
      {
        question: "I have a Danshaker with a high frame – can it be converted to a low frame?",
        answer: "<p>Yes, the low frame can be purchased and retrofitted easily, quickly, and simply.</p>"
      },
      {
        question: "Can I rent a Danshaker?",
        answer: "<p>Yes, you can rent a Danshaker for a month and test it in your own stable before making a final purchasing decision – completely without obligation.</p>"
      },
      {
        question: "Do you sell your rental machines?",
        answer: "<p>No, our rental fleet is strictly for trials. When ordering, you receive a brand-new machine with full manufacturer warranty and top quality.</p>"
      },
      {
        question: "What is the typical delivery time?",
        answer: "<p>We strive to deliver your Danshaker within six weeks of ordering, so you can quickly start saving time, effort, and bedding.</p>"
      }
    ],
    tilbehoer: [
      {
        name: "Custom Colors",
        description: "Available in all RAL colors",
        price: "€ 135.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/a91119ee-cb50-4bb0-8636-9ff6a6aa87e2.jpg"]
      },
      {
        name: "Wheelbarrow Mount",
        description: "Mount for wheelbarrow",
        price: "€ 135.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/e78bab06-df3e-49dd-b2cd-e5a4891479a9.jpg"]
      },
      {
        name: "Side Chute Discharge",
        description: "Manually adjustable, left or right.",
        price: "€ 670.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/80ade798-7838-4838-ba9d-88d0e973e725.jpg"]
      },
      {
        name: "Bottle Holder",
        description: "Magnetic attachment.",
        price: "€ 55.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"]
      },
      {
        name: "Tool Holder",
        description: "20-30 mm or 25-35 mm. Per set.",
        price: "€ 80.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg"]
      },
      {
        name: "Rubber Scraper Brake",
        description: "For leveling riding arena footing.",
        price: "€ 135.-",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg"]
      }
    ],
    galleri: [
      {
        title: "Danshaker Details",
        slug: "danshaker-details",
        images: [
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/danshaker-3-farver_e98ea2d5.png",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/88965ac8-a30d-41c2-b3d4-878dd054d8f1.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/de8c8522-492e-4e3d-b905-652dfdcf1c5e.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/735ab98a-19ad-4a44-8706-12f21749ddce.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"
        ]
      }
    ]
  },
  de: {
    testimonials: [
      {
        id: "nis-1",
        name: "Nis Friis Virenfeldt",
        company: "DK • 4 Bewertungen • 31. Jan. 2026",
        text: "<p><strong>Hohe Qualität und erstklassiger Service!</strong></p><p>Wir haben unseren Danshaker jetzt seit einem Jahr – wenn wir etwas anders machen könnten, hätten wir ihn schon viel früher gekauft!</p><p>Er wird täglich für 10 Pferde/Ponys genutzt und bringt eine große Ersparnis bei den Hobelspänen. Das führt auch zu deutlich längeren Entleerungsintervallen des Mistcontainers!</p><p>Wir haben einen fantastischen Service von Rasmus erlebt. Er ist ein Technik-Enthusiast, der sich regelmäßig meldet, um die Kundenzufriedenheit sicherzustellen, und die Ausrüstung ständig verbessert.</p><p>Größte Empfehlung von uns🙏🐴</p>",
        image: []
      },
      {
        id: "sanne-1",
        name: "Sanne",
        company: "DK • 8 Bewertungen • 2. Feb. 2026",
        text: "<p><strong>Fantastische Erfahrung mit Danshaker</strong></p><p>Ich hatte ein wirklich tolles Erlebnis mit Danshaker, bei dem Rasmus von Anfang bis Ende einen persönlichen und zuvorkommenden Service geleistet hat. Man fühlt sich rundum gut beraten und betreut.</p><p>Das Produkt ist von hoher Qualität, und unseren Pferden geht es damit hervorragend. Der lockere, luftige Boxenboden bringt eine spürbare Verbesserung des Komforts – der Untergrund ist sowohl angenehmer als auch elastischer für das Pferd.</p><p>Zudem habe ich eine deutliche Ersparnis beim Verbrauch von Holzpellets sowie bei der täglichen Arbeitszeit im Stall festgestellt.</p><p>Alles in allem kann ich Danshaker wärmstens empfehlen – dank des hervorragenden Services, der hohen Qualität und des gesteigerten Wohlbefindens für die Pferde.</p>",
        image: []
      },
      {
        id: "1",
        name: "Team Madsbjerg",
        company: "Team Madsbjerg",
        text: "<p>Rasmus von Danshaker steht zu 100 % hinter dem, was er sagt und verspricht – das ist genauso wichtig wie das Produkt, das er verkauft.</p><p>Wir freuen uns jeden Tag darauf, in den Stall zu gehen und die Maschine zu benutzen.</p><p>Die Maschine ist kinderleicht zu bedienen und schafft gleichzeitig einen wunderbar lockeren und weichen Boden.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/869578f4-4087-49ae-9256-01442dfeaff9.jpg"]
      },
      {
        id: "2",
        name: "Dan Jeppesen",
        company: "Molger Reitklub",
        text: "<p>Die Maschine hat in unserem Stall einen riesigen Unterschied gemacht – sowohl für das Personal als auch für die Vereinsmitglieder.</p><p>Es ist viel einfacher geworden, den Boxenboden instand zu halten, und wir spüren bereits, wie viel leichter der Alltag geworden ist.</p><p>Die Pferde stehen viel weicher, und das merkt man ihnen wirklich an – das bedeutet uns sehr viel!</p><p>Vielen Dank für diese hervorragende Lösung – wir sind absolut begeistert! Beste Empfehlungen von uns.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ee3409b4-4a03-4472-bb2f-a5861cc8d979.jpg"]
      },
      {
        id: "3",
        name: "M-Horses",
        company: "M-Horses",
        text: "<p>Wir sind sehr zufrieden mit der Maschine, da sie einfach zu bedienen, leicht zu manövrieren und sehr einstrewirksam ist.</p><p>Wir brauchen auch deutlich weniger Zeit für das Misten als zuvor.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/dca27bba-1daf-44d2-87c2-ae31a6dff125.jpg"]
      },
      {
        id: "4",
        name: "Michelle Lauridsen",
        company: "Stald Bøgen, Esbjerg",
        text: "<p>Wir haben mehrere Pferde in unserem Stall, die extrem viel Dreck machen.</p><p>Früher dauerte das Ausmisten in diesen Boxen 30–40 Minuten pro Box – seitdem wir den Danshaker haben, liegt diese Zeit unter 10 Minuten pro Box.</p><p>Unsere Stallhilfe mistet täglich unsere 10 Boxen aus. Normalerweise war sie nach 4–5 Boxen völlig erschöpft, aber mit dem Danshaker schafft sie alle 10 Boxen mühelos und hat noch Energie für andere Arbeiten im Stall. Wir können den Danshaker wärmstens empfehlen und vergeben 10/10 Sterne.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/500774ed-a863-4e49-9e78-26eeb7273db5.jpg"]
      },
      {
        id: "5",
        name: "Odgaard Horses",
        company: "Odgaard Horses",
        text: "<p>Wir nutzen die Maschine seit Jahresbeginn täglich und sind besonders begeistert davon, die belastenden, repetitiven Bewegungen beim Ausmisten loszuwerden.</p><p>Es ist einfach, die Einstreu in die Maschine zu schaufeln, und jeder im Stall findet schnell seinen Rhythmus. Wir stellen weniger Mistmenge und schnelleres Arbeiten fest. Eine rundum lohnende Investition.</p>",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ce39733b-86c6-4c8a-83d0-06b042411306.jpg"]
      }
    ],
    nyheder: [
      {
        id: "n1",
        title: "Personalisieren Sie Ihren Danshaker",
        date: "19. Januar 2026",
        content: "<p>Jetzt können Sie Ihren neuen Danshaker ganz individuell gestalten, indem Sie genau die RAL-Farbe wählen, die Ihnen am besten gefällt.</p><p>Gegen einen geringen Aufpreis bieten wir auch Glitzerpartikel im Lack an.</p><p>Alle zukünftigen Modelle erhalten ab sofort vollständig schwarze Vorderräder anstelle der gelben.</p>",
        slug: "personalisieren-sie-ihren-danshaker"
      },
      {
        id: "n2",
        title: "Privatfinanzierung",
        date: "19. Januar 2026",
        content: "<p>Jetzt können Sie Ihren neuen Danshaker privat finanzieren – ab nur 1.563 DKK/Monat inkl. MwSt.</p><p>Wir arbeiten mit flexiblen Partnern zusammen, um Ihnen passende Ratenzahlungsmodelle anzubieten.</p><p>Teilen Sie den Gesamtbetrag in kleinere Monatsraten auf bis zu 24 Monate auf. Kontaktieren Sie uns noch heute.</p>",
        slug: "privatfinanzierung"
      }
    ],
    faq: [
      {
        question: "Benötigt der Danshaker während der Arbeit ein Stromkabel?",
        answer: "<p>Nein – Sie sind komplett kabellos unterwegs. Der Danshaker wird von einem leistungsstarken wiederaufladbaren Akku angetrieben, sodass Sie volle Bewegungsfreiheit haben.</p>"
      },
      {
        question: "Wie viele Boxen schaffe ich mit einer Akkuladung?",
        answer: "<p>Mit einer vollen Ladung können Sie bis zu 86 Boxen à ca. 10 Minuten bearbeiten. Das bietet enorme Kapazität – selbst für Großbetriebe.</p>"
      },
      {
        question: "Wie lange dauert das Aufladen des Danshakers?",
        answer: "<p>Von 10 % auf 100 % dauert es üblicherweise 5–6 Stunden. Schließen Sie ihn über Nacht an, und er ist am nächsten Morgen wieder voll einsatzbereit.</p>"
      },
      {
        question: "Wie viel Zeit spare ich mit dem Danshaker?",
        answer: "<p>Viele unserer Kunden haben ihre Entmistungszeit halbiert – manche sparen bis zu 75 %. So bleibt mehr Zeit für die Pferde und weniger für schwere Handarbeit.</p>"
      },
      {
        question: "Wie viel Einstreu kann ich einsparen?",
        answer: "<p>Unsere Kunden verzeichnen oft bis zu 50 % weniger Einstreuverbrauch – und gleichzeitig spürbar weniger Arbeitsaufwand bei der Mistentsorgung.</p>"
      },
      {
        question: "Wann hat sich der Danshaker amortisiert?",
        answer: "<p>Das ist individuell verschieden. Im Durchschnitt sparen Kunden rund 50 % bei Einstreukauf und Mistentsorgung. Bei täglichem Einsatz mit feiner Einstreu wie Spänen oder Pellets rentiert sich die Maschine besonders zügig.</p>"
      },
      {
        question: "Mit welchen Einstreuarten funktioniert der Danshaker?",
        answer: "<p>Er ist mit allen gängigen Einstreumaterialien getestet: Hobelspänen, Holzpellets, Sägemehl, Leinen/Hanf und Torf. Je feiner das Material, desto mehr saubere Einstreu wird getrennt.</p>"
      },
      {
        question: "Gibt es Einstreu, die für den Danshaker ungeeignet ist?",
        answer: "<p>Ja, von der Verwendung in klassischem Langstroh oder bei sehr groben Hackschnitzeln raten wir ab, da das Siebergebnis dort nicht optimal ist.</p>"
      },
      {
        question: "Kann ich die Geschwindigkeit des Danshakers anpassen?",
        answer: "<p>Ja – die Rüttelgeschwindigkeit lässt sich bequem per Smartphone regeln, passend zu Ihrem persönlichen Arbeitstempo.</p>"
      },
      {
        question: "Ist der Danshaker nach Gebrauch schwer zu reinigen?",
        answer: "<p>Nein – die Reinigung dauert im Waschplatz mit dem Wasserschlauch nur etwa eine Minute. Schnell, einfach und startklar.</p>"
      },
      {
        question: "Kann ich Zubehör an meinem Danshaker nachrüsten?",
        answer: "<p>Ja, bei allen Danshaker 2.0 Modellen (blaue Ausführung) lässt sich jedes Zubehörteil problemlos und jederzeit nachrüsten.</p>"
      },
      {
        question: "Ich habe einen Danshaker mit hohem Rahmen – lässt er sich auf niedrigen Rahmen umbauen?",
        answer: "<p>Ja, der niedrige Rahmen kann separat bestellt und schnell und unkompliziert montiert werden.</p>"
      },
      {
        question: "Kann man den Danshaker mieten?",
        answer: "<p>Ja, Sie können einen Danshaker für einen Monat mieten und im eigenen Stall auf Herz und Nieren testen – vollkommen unverbindlich.</p>"
      },
      {
        question: "Verkaufen Sie Mietmaschinen?",
        answer: "<p>Nein, unsere Mietflotte dient ausschließlich Teststellungen. Bei Kauf erhalten Sie stets eine fabrikneue Maschine mit voller Garantie.</p>"
      },
      {
        question: "Wie lang ist die Lieferzeit?",
        answer: "<p>Wir bemühen uns, Ihren Danshaker innerhalb von sechs Wochen ab Bestellung auszuliefern.</p>"
      }
    ],
    tilbehoer: [
      {
        name: "Sonderfarben",
        description: "In allen RAL-Farben lieferbar",
        price: "135,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/a91119ee-cb50-4bb0-8636-9ff6a6aa87e2.jpg"]
      },
      {
        name: "Schubkarren-Aufhängung",
        description: "Halterung für Schubkarre",
        price: "135,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/e78bab06-df3e-49dd-b2cd-e5a4891479a9.jpg"]
      },
      {
        name: "Seitlicher Auswurf",
        description: "Manuell einstellbar, links oder rechts.",
        price: "670,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/80ade798-7838-4838-ba9d-88d0e973e725.jpg"]
      },
      {
        name: "Trinkflaschenhalter",
        description: "Mit Magnetbefestigung.",
        price: "55,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"]
      },
      {
        name: "Werkzeughalter",
        description: "20-30 mm oder 25-35 mm. Pro Set.",
        price: "80,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg"]
      },
      {
        name: "Gummibremse",
        description: "Zur Pflege und Egalisierung des Reitplatzbodens.",
        price: "135,- €",
        image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg"]
      }
    ],
    galleri: [
      {
        title: "Danshaker Details",
        slug: "danshaker-details",
        images: [
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/danshaker-3-farver_e98ea2d5.png",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/88965ac8-a30d-41c2-b3d4-878dd054d8f1.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/de8c8522-492e-4e3d-b905-652dfdcf1c5e.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/735ab98a-19ad-4a44-8706-12f21749ddce.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg",
          "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"
        ]
      }
    ]
  }
};
